import React from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import {
  AuControlInput,
  AuFormGroup,
  AuInputLabel,
  AuHintText,
  AuErrorText
} from 'components/DTA';

interface IControlInputOption {
  label: string | React.ReactElement;
  hintText?: string;
  value: string | number;
  id?: string;
}

export interface IControlInputGroup {
  name: string;
  errorName?: string;
  type: 'checkbox' | 'radio';
  options: Array<IControlInputOption>;
  label?: string;
  hintText?: string;
  block?: boolean;
  disabled?: boolean;
  small?: boolean;
}


const ControlInputGroup: React.FC<IControlInputGroup> = ({ name, type, options, label, hintText, block = true,  small = false, disabled = false }) => {
  const { getFieldMeta, errors } = useFormikContext();

  return (
    <AuFormGroup status={getFieldMeta(name).error && !disabled ? 'invalid' : 'valid'}>
      {
        label && <AuInputLabel text={label} htmlFor={name} />
      }
      {
        hintText && <AuHintText text={hintText} htmlFor={name} />
      }
      {
        options.map(option =>
          <AuControlInput
            key={`${option.value}`}
            name={name}
            value={option.value}
            id={option.id ? option.id : (option.value ? option.value?.toString() : name)}
            type={type}
            label={option.label}
            hintText={option.hintText}
            disabled={disabled}
            small={small}
            block={block} />
        )
      }
      {
        getFieldMeta(name).error && !disabled &&
          <AuErrorText text={get(errors, name)} />
      }
    </AuFormGroup>
  );
};

export default ControlInputGroup;